import { useCookies } from 'react-cookie';

import { getGTMKey } from 'app/ga/gaKeys';
import { TRACKING_CONSENT_COOKIE } from 'shared/constants/cookies';

/**
 * Whether the cookie-consent banner is currently shown (consent not yet given and GTM configured).
 * Single source of truth so the banner and the page focus management stay in sync (L1S-1402).
 */
export const useIsCookieConsentVisible = (): boolean => {
  const [cookies] = useCookies([TRACKING_CONSENT_COOKIE]);

  return cookies[TRACKING_CONSENT_COOKIE] === undefined && !!getGTMKey();
};
